module.exports = __webpack_public_path__ + "img/4_155.872af9a4.png";